import { render, staticRenderFns } from "./DataAnalysisDashboardGruppiListComponent.vue?vue&type=template&id=59cc393b"
import script from "./DataAnalysisDashboardGruppiListComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardGruppiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports